import React from "react";
import { View, FlatList } from "react-native";
import { Text } from "../../Text";
import LineItem from "./LineItem";
import { useTranslateText } from "@/app/utils/translations";
import { LineItemWithProdType } from "@/app/types/line-items";
import { basketItemsStyles as styles } from "./styles";
import { colors } from "@/app/constants/styles";

export const renderSeparator = (height: number) => (
  <View style={[styles.listSeparator, { height }]} />
);

type BasketItemsProps = {
  onEditItem: (id: string) => void;
  lineItems: LineItemWithProdType[];
};

export const BasketItems = ({ onEditItem, lineItems }: BasketItemsProps) => {
  const { t } = useTranslateText();
  const selectedBasketItem = undefined;

  return (
    <FlatList
      contentContainerStyle={{
        flexGrow: 1,
        paddingHorizontal: 20,
        paddingBottom: 80,
        backgroundColor: colors.white,
      }}
      ItemSeparatorComponent={() => renderSeparator(1)}
      ListEmptyComponent={
        <Text style={styles.emptyBasketText}>
          {t("checkoutScreen.groupOrder.notAddedItems")}
        </Text>
      }
      data={lineItems}
      keyExtractor={({ id }) => `${id}`}
      renderItem={({ item }) => {
        const isBasketItemSelected = selectedBasketItem === item.id;
        return (
          <View
            style={[
              styles.listItemContainer,
              {
                backgroundColor: isBasketItemSelected
                  ? colors.maroon
                  : "transparent",
              },
            ]}
          >
            <LineItem
              onItemPress={(id: string) => onEditItem(id)}
              item={item}
            />
          </View>
        );
      }}
    />
  );
};
